import { useEffect, useState } from 'react';
import { fetchWebsiteFeatures, WebsiteFeature } from '@/services/featureListService';

/**
 * Hook to fetch the features an admin flagged "Show on website". Empty until
 * the read finishes, and stays empty if it fails.
 */
export const useWebsiteFeatures = () => {
  const [features, setFeatures] = useState<WebsiteFeature[]>([]);

  useEffect(() => {
    let cancelled = false;

    // Never throws — a failed read resolves null and is already reported.
    fetchWebsiteFeatures().then((result) => {
      if (!cancelled) {
        setFeatures(result ?? []);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return features;
};
